import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import CardContent from "@mui/material/CardContent";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { get } from "lodash";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useMaterialUIController } from "context";
import bookedImg from "../../../assets/images/booked.svg";
import MDButton from "components/MDButton";
import { amountToShow } from "global/functions";

const PaymentResultPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const { darkMode } = controller;

  console.log("state --->", state);
  useEffect(() => {
    if (!state || !state?.status) {
      navigate("/test");
    }
  }, [dispatch, navigate, state]);

  useEffect(() => {
    setTimeout(() => {
      console.log("close window parking (useEffect)----->");
      if (typeof window.postMessage !== "undefined") {
        console.log("enter if ====>");
        const responseObj = {
          eventData: {
            sessionId: state?.data?.sessionId,
            errorMessage: state?.data?.message,
          },
          eventName:
            state?.status === "paid" || state?.status === "alreadyPaid"
              ? "paymentsuccess"
              : "paymentfailed",
        };
        console.log("responseObj ====>",responseObj)
        window.parent.postMessage(responseObj, "*");
      }
    }, 1000);
  }, []);

  const renderSubscriptionInfo = () => {
    if (state?.status !== "paid") return null;
    return (
      <Grid item xs={12} md={8} lg={5}>
        <Paper variant="outlined" className="mb-2">
          <CardContent>
            {renderStack(
              "Transient ID :",
              get(state, "data.transientNumber", "")
            )}
            {renderStack(
              "Total :",
              ` $${
                state.data?.isMonthly
                  ? amountToShow(state.data.firstMonthTotalAmount)
                  : amountToShow(state.data.totalAmount)
              } `
            )}
          </CardContent>
        </Paper>
      </Grid>
    );
  };

  const renderStack = (label, value) => (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      justifyContent="space-between"
      className="mb-2"
    >
      <Typography variant="subtitle1">{label}</Typography>
      <Typography variant="h6" color="secondary" className="fw-bold">
        {value}
      </Typography>
    </Stack>
  );



  return (
    <Box
      component="section"
      sx={{ py: { sm: 6.4, xs: 4 } }}
      className="d-flex align-items-center justify-content-center flex-wrap w-100"
    >
      <Container maxWidth="lg">
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={10} sm={8} md={6} lg={5} className="text-center">
            <Box component="img" src={bookedImg} className="img-fluid" />
          </Grid>
          <Grid item xs={12} md={8} className="text-center">
            <Typography variant="h4" color="success" className="mb-2">
              {/* Payment{" "} */}
              {state?.status === "paid"
                ? "Yay! Payment Successful!"
                : state?.status === "expired"
                ? "Oops! Sorry this payment link was expired. Please try again!"
                : state?.status === "invalid"
                ? "Oops! Invalid Payment Link!"
                : state?.status === "failed"
                ? "Oops! Your Payment was Failed!"
                : state?.status === "alreadyPaid"
                ? "Heads up! Your payment is already in process."
                : ""}
            </Typography>
            <Typography
              variant="subtitle2"
              color={darkMode ? "#ffffff" : "#1c1c1c"}
            >
              {state?.status === "paid"
                ? "Once the payment is fully processed, you will receive a notification via email and/or SMS."
                : state?.status === "expired"
                ? "Oops! Sorry this payment link was expired. Please try again!"
                : state?.status === "invalid"
                ? "Oops! Invalid Payment Link!"
                : state?.status === "failed"
                ? `${state.data.message}`
                : state?.status === "alreadyPaid"
                ? "Looks like you've already paid for this license plate! A confirmation SMS will be on its way shortly."
                : ""}
            </Typography>
          </Grid>
          {renderSubscriptionInfo()}
          <Grid item xs={12}>
            <Stack
              direction={{ sm: "row", xs: "column" }}
              spacing={1}
              alignItems="center"
              justifyContent="center"
            >
                           {state?.status === "failed" && (
                <MDButton
                  color={sidenavColor}
                  variant="contained"
                  sx={{ width: { xs: "230px", md: "250px" } }}
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  Go back to pay again
                </MDButton>
              )}
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default PaymentResultPage;
